import {
  RemoveUserFromLocation,
  Location,
  ApiClientError,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useRemoveUserFromLocation() {
  const queryClient = useQueryClient();
  const mutation = useProtectedMutation<
    Location,
    ApiClientError,
    { locationId: string; params: Partial<RemoveUserFromLocation> },
    Location[]
  >(
    ({ locationId, params }) =>
      raydiant.removeUserFromLocation(locationId, params),
    {
      onSuccess: (data) => {
        const locations =
          queryClient.getQueryData<Location[]>(keys.locations()) || [];

        const selectedIndex = locations.findIndex(
          (location) => location.id === data.id,
        );
        const updatedLocations = [...locations];
        updatedLocations[selectedIndex] = data;

        queryClient.setQueryData(keys.locations(), updatedLocations);
      },
    },
  );

  return mutation;
}
